// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import iconFactory from 'syft-acp-atoms/Icons'

export const IconClock = iconFactory('clock', 'Notifications')
